import React from "react";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";

const BottomNav = ({ actions }) => {
  return (
    <BottomNavigation
      showLabels
      sx={{
        minWidth: {
          xs: "max-content",
          sm: "100%",
        },

        display: "flex",
        justifyContent: {
          xs: "flex-start",
          sm: "center",
        },

        height: {
          xs: 65,
          sm: 75,
        },
      }}
    >
      {actions.map((action, index) => (
        <BottomNavigationAction
          key={index}
          label={action.label}
          icon={React.cloneElement(action.icon, {
            sx: { color: action.color },
          })}
          onClick={action.onClick}
          sx={{
            minWidth: {
              xs: 90,
              sm: "auto",
            },

            maxWidth: {
              xs: 100,
              sm: 160,
            },

            flex: {
              sm: 1,
            },

            display: "flex",
            justifyContent: "center",
            alignItems: "center",

            "& .MuiBottomNavigationAction-label": {
              fontSize: {
                xs: "0.65rem",
                sm: "0.75rem",
              },
            },
          }}
        />
      ))}
    </BottomNavigation>
  );
};

export default BottomNav;
